import { render, staticRenderFns } from "./SubmitMessage.vue?vue&type=template&id=90c06bc8&scoped=true&"
import script from "./SubmitMessage.vue?vue&type=script&lang=js&"
export * from "./SubmitMessage.vue?vue&type=script&lang=js&"
import style0 from "./SubmitMessage.vue?vue&type=style&index=0&id=90c06bc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c06bc8",
  null
  
)

export default component.exports